export const FETCH_RECENTLY_ADDED_SKILLS_SUCCESS = 'FETCH_RECENTLY_ADDED_SKILLS_SUCCESS';
export const FETCH_RECENTLY_ADDED_SKILLS_FAILURE= 'FETCH_RECENTLY_ADDED_SKILLS_FAILURE';
